import styled, { css } from 'styled-components';
import { Avatar } from 'components/atoms/avatar';
import { AvatarProps } from 'components/atoms/avatar/types';
import { ProductiveHeading07 } from 'components/styles/typography';

export const LogoContainer = css`
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
  filter: var(--shadow-01);
  border-radius: var(--spacing-01);
  padding: var(--spacing-01);
`;

// TODO:: make size proper as xxlarge
export const Logo = styled(Avatar)<AvatarProps>`
  ${LogoContainer};
  .ant-avatar-string {
    font-size: ${({ size }) =>
      `${size === 88 ? 'var(--heading-3-size)' : 'var(--font-size-base)'}`};
  }
`;

export const LogosContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  && p {
    margin: 0 16px;
    ${ProductiveHeading07};
  }
`;
